import { useState } from "react"
import { Link, useParams } from "react-router-dom"
import { useSession } from "../../auth/session"
import { useSku } from "../../redux/skusSlice"
import {
  EntitlementOrigin,
  EntitlementStatus,
  entitlementOriginLabels,
  entitlementStatusLabels,
  UserSearchResult,
} from "../../api/models"
import UserFilter from "../widgets/UserFilter"
import ChipSelect from "../widgets/ChipSelect"
import EntitlementsTable from "../EntitlementsTable"

export default function SkuEntitlements() {
  const { id } = useParams<{ id: string }>()
  const session = useSession()
  const accessToken = session.accessToken ?? ""
  const { data: sku } = useSku(id!)

  // filters are AND-combined; the backend does the same
  const [userFilter, setUserFilter] = useState<UserSearchResult | null>(null)
  const [originFilter, setOriginFilter] = useState<"" | EntitlementOrigin>("")
  const [statusFilter, setStatusFilter] = useState<"" | EntitlementStatus>("")

  return (
    <div className="page">
      <Link to={`/skus/${id}`} className="back-link">&larr; {sku?.name ?? "SKU"}</Link>
      <h1 className="page-title">{sku?.name ? `${sku.name} Users` : "Users"}</h1>

      <div className="filter-bar">
        <UserFilter selected={userFilter} onSelect={setUserFilter} accessToken={accessToken} />
        <ChipSelect
          value={originFilter}
          onChange={setOriginFilter}
          options={Object.values(EntitlementOrigin)}
          labels={entitlementOriginLabels}
          placeholder="All origins"
        />
        <ChipSelect
          value={statusFilter}
          onChange={setStatusFilter}
          options={Object.values(EntitlementStatus)}
          labels={entitlementStatusLabels}
          placeholder="All statuses"
        />
      </div>

      <EntitlementsTable
        skuId={id!}
        userId={userFilter?.id ?? null}
        origin={originFilter || null}
        status={statusFilter || null}
        showUserColumn
        accessToken={accessToken}
      />
    </div>
  )
}
